import clsx from 'clsx';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
};
export function DialogBody(props: Props) {
  const cn = clsx('shrink grow basis-2/3', props.className);

  return (
    <div {...props} className={cn}>
      {props.children}
    </div>
  );
}

DialogBody.displayName = 'DialogBody';
